import { render, staticRenderFns } from "./candidates.vue?vue&type=template&id=19190db2&scoped=true"
import script from "./candidates.vue?vue&type=script&lang=js"
export * from "./candidates.vue?vue&type=script&lang=js"
import style0 from "./candidates.vue?vue&type=style&index=0&id=19190db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19190db2",
  null
  
)

export default component.exports